import { where, limit } from 'firebase/firestore'
import { FirestoreRepository } from '@upadelmatch/core'
import { PadelPlaceSchema, type PadelPlace } from '@/core/models/padel-place'

// `places_courts` — the club directory projected from clubmanager (read-only
// for clients; the CF is the only writer). Both queries are equality-only, so
// Firestore serves them by merging single-field indexes — no composite needed
// until the geohash RANGE query ships with proximity search.
class PlacesRepository extends FirestoreRepository<typeof PadelPlaceSchema> {
  constructor() {
    super('places_courts', PadelPlaceSchema)
  }

  listActiveByCityKey(cityKey: string): Promise<PadelPlace[]> {
    return this.list(where('cityKey', '==', cityKey), where('isActive', '==', true))
  }

  /** Whole active directory — the place picker's haystack (small at this stage). */
  listActive(): Promise<PadelPlace[]> {
    return this.list(where('isActive', '==', true), limit(200))
  }
}

export const placesRepository = new PlacesRepository()
